/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Mountain = [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z" }]];

export { Mountain as default };
//# sourceMappingURL=mountain.js.map
